import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { IxActionRightsMap, IxActionRight, IxModuleRights } from 'enums/rights-enum'

export const checkActionRight = (moduleRights: IxModuleRights, a: any) => {
    if (moduleRights === null || IxActionRightsMap[a.actionRights].includes(moduleRights)) {
        return a.actionDef
    } else {
        return {
            ...a.actionDef,
            widget: 'disabledbtn',
            hint: 'You don\'t have sufficient rights to use this action'
        }
    }
}

const ActionRightToEnumMap: any = {
    'Admin': IxActionRight.SuperRights,
    'Change': IxActionRight.EditRights,
    'Delete': IxActionRight.DeleteRights,
    'Bank': IxActionRight.EditBankRights,
}

export const _checkActionRight = (moduleRight: IxModuleRights | null, actionRight: any) => {
    let _actionRight = actionRight
    if (typeof actionRight === 'string') { _actionRight = ActionRightToEnumMap[actionRight] }

    if (!moduleRight || (actionRight === undefined || actionRight === '') || IxActionRightsMap[_actionRight].includes(moduleRight)) {
        return true
    } else {
        return null
    }
}

export const useIxCheckActionRight = () => {
    const moduleRights = useSelector((state: any) => state.rights)

    const checkActionRight = useCallback((moduleName: string, actionRight: any) => {
        const moduleRight = (moduleRights[moduleName] && moduleRights[moduleName].status === 'loaded')
            ? moduleRights[moduleName]?.right
            : null

        let _actionRight = typeof actionRight === 'string' ? ActionRightToEnumMap[actionRight] : actionRight

        return moduleRight === null || moduleRight === '' || actionRight === ''
            || (_actionRight !== undefined && IxActionRightsMap[_actionRight].includes(moduleRight))
    }, [moduleRights])

    return checkActionRight
}
